import MagstimTableData from './MagstimTableData';
import { CurrentLang } from 'common';
import * as StringUtils from 'common/utils/StringUtils.js'

class MagstimTableDataPatientAdditional extends MagstimTableData {

    getNamedValuePairs(data) {

        let tableData = [];
        //console.log("details getNamedValuePairs", this.props.data);

        tableData = [
            { name: CurrentLang().edit_patient_handedness_label, value: StringUtils.formatStringOrNoData(data.Handedness, CurrentLang().no_data) },
            { name: CurrentLang().edit_patient_ethnicity_label, value: StringUtils.formatStringOrNoData(data.Ethnicity, CurrentLang().no_data) },
            { name: CurrentLang().edit_patient_managing_physician_label, value:StringUtils.formatStringOrNoData( data.ManagingPhysician, CurrentLang().no_data) },
            { name: CurrentLang().edit_patient_referring_physician_label, value: StringUtils.formatStringOrNoData(data.ReferringPhysician, CurrentLang().no_data) },
            { name: CurrentLang().edit_patient_insurance_provider_label, value: StringUtils.formatStringOrNoData(data.InsuranceProvider, CurrentLang().no_data) }]

        return tableData;
    }
}

export default MagstimTableDataPatientAdditional;
